module.exports = __webpack_public_path__ + "static/media/1POLICY40.523a9e1a.jpg";